import type { MisconceptionDefinition } from '../types'

/** SPR — Overige aa/ee/oo-klank, bakker/jager-verwarring & D/T error-spotting (slice 6). */
export const klankOverigeDtMisconceptions: MisconceptionDefinition[] = [
  {
    id: 'spr.bomen-fout-gedacht',
    label: 'Correct gespeld woord als fout gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat correct gespeld "bomen" fout is en "boomen" moet zijn.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.tweeklank-verward',
    label: 'Tweeklank verward met lange klinker',
    module: 'SpellingRegel',
    description:
      'Leerling verwart een tweeklank (oe, eu, ui) met een lange klinker (oo, ee, aa).',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.ramen-dubbel',
    label: 'Denkt dat ramen dubbele aa nodig heeft',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "ramen" als "raamen" geschreven moet worden.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  // Removed mei 2026: spr.dubbel-ee-open and spr.dubbel-klinker-en-medeklinker-ee
  // were EE-specific instances of the generic rules. Merged into the generic
  // spr.dubbel-klinker-open (covers aa/ee/oo) and spr.dubbel-klinker-en-medeklinker
  // respectively. The seed-level `label` preserves the EE-specific phrasing where
  // useful. Verified zero seed usage of either EE-specific id post-migration.
  {
    id: 'spr.bakker-jager-verward',
    label: 'Bakker-regel en jager-regel verward',
    module: 'SpellingRegel',
    description:
      'Leerling verwart de bakker-regel (korte klank in gesloten lettergreep → dubbele medeklinker: bak-ker) met de jager-regel (lange klank in open lettergreep → enkele medeklinker: ja-ger). De twee spellingregels worden door elkaar gehaald, vaak omdat de leerling niet eerst de lettergreep classificeert.',
    typicalFamilies: [
      'SPR-KLANK-AA-EE-OO',
      'SPR-KLANK-BAKKER',
      'SPR-KLANK-JAGER',
      'SPR-KLANK-VERDUBBEL',
      'SPR-KLANK-VERKORTEN',
    ],
  },
  {
    id: 'spr.correct-als-fout',
    label: 'Correct woord als fout gezien',
    module: 'SpellingRegel',
    description: 'Leerling denkt dat een correct gespeld woord fout is.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.betekenis-vs-spelling',
    label: 'Betekenisfout verward met spellingfout',
    module: 'SpellingRegel',
    description: 'Leerling verwart een betekenisfout met een spellingfout.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.medeklinker-focus',
    label: 'Focust op medeklinkers i.p.v. klinkers',
    module: 'SpellingRegel',
    description:
      'Leerling focust op medeklinkerfouten terwijl de klinkerregel het probleem is.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.open-dubbel-verward',
    label: 'Open lettergreep vereist twee klinkers',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat je in een open lettergreep twee klinkers naast elkaar schrijft.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.altijd-dubbel',
    label: 'Lange klinkers altijd dubbel',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat lange klinkers altijd dubbel geschreven worden, ongeacht het type lettergreep.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.open-gesloten-omgedraaid',
    label: 'Open en gesloten lettergreep omgedraaid',
    module: 'SpellingRegel',
    description:
      'Leerling verwisselt de regels voor open en gesloten lettergrepen.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },

  // ─── D/T error-spotting (overcorrectie & verwante eindletters) ──────────
  {
    id: 'spr.d-t-correct-onterecht-fout',
    label: 'Correct d/t-woord onterecht als fout aangewezen',
    module: 'SpellingRegel',
    description:
      'Leerling wijst in een error-spotting taak een correct gespeld d/t-woord aan als fout (overcorrectie). Symptoom van onvoldoende vertrouwen in de regel "maak het langer": de leerling twijfelt en kiest een goed woord als verdacht.',
    typicalFamilies: ['SPR-WEET-D-T-ERROR'],
  },
  {
    id: 'spr.d-t-w-verward',
    label: 'D/t-eind verward met w-eind',
    module: 'SpellingRegel',
    description:
      'Leerling herkent niet dat een woord op -w eindigt en behandelt het alsof het op -d of -t eindigt (bijv. "geboud" voor "gebouw"). De truc "maak het langer" zou onthullen dat gebouwen op -w klinkt, niet op -d.',
    typicalFamilies: ['SPR-WEET-D-T-ERROR', 'SPR-WEET-D-T'],
  },
]
